import React from 'react';
import { __, STR_KEY } from '../../services/Translate';
import Utils from '../../services/utils/utils';
import HtmlWrapper from '../HtmlWrapper';
import './styles.scss';

const Hosts = ({ hosts }) => {
    if (!hosts.length || !hosts) return null;

    const title = hosts.length > 1 ? __(STR_KEY.MODAL_SESSION_TITLE_HOSTS) : __(STR_KEY.MODAL_SESSION_TITLE_HOST);

    return (
        <div className="EventHosts">
            <h2 className="hostsSectionTitle" role="heading" aria-level="2">{title}</h2>
            {renderHosts(hosts)}
        </div>
    )
}

const renderHosts = (hosts) => {
    return hosts.map((host, i) => {
        return (
            <Host host={host} index={i} />
        );
    });
}

const Host = ({ host }) => {
    return (
        <div className="hostContainer">
            <div className="hostHeading">
                {renderHostAvatar(host.avatar)}
                <div className="hostHeadingText">
                    <p className="hostName">
                        {host.title} {host.first_name} {host.last_name}
                    </p>
                    <p className="hostPosition">{host.position}</p>
                </div>
            </div>
            {host.bio ? <HtmlWrapper html={host.bio} /> : null}
            {renderSocialOptions(host.social_options)}
        </div>
    );
}

const renderSocialOptions = (hostSocialOptions) => {
    if (!hostSocialOptions) return null;

    const socialOptions = JSON.parse(hostSocialOptions);

    const renderLink = (link) => (link.indexOf('://') === -1) ? 'http://' + link : link;

    return (
        <div className="socialIcons">

            {
                socialOptions.website ?
                    <a href={renderLink(socialOptions.website)}
                        target="_blank"
                        aria-label="Visit the organiser's website">
                        <i className="far fa-link"></i>
                        <span  className="sr-only">link to host's website</span>
                     </a> : null        
            }

            {
                socialOptions.twitter ?
                    <a href={renderLink(socialOptions.twitter)}
                        target="_blank"
                        aria-label="Visit the organiser's Twitter page">
                        <i className="fab fa-twitter"></i>
                        <span  className="sr-only">link to host's twitter account</span>
                    </a> : null
            }

            {
                socialOptions.linkedin ?
                    <a href={renderLink(socialOptions.linkedin)}
                        target="_blank"
                        aria-label="Visit the organiser's LinkedIn page">
                        <i className="fab fa-linkedin"></i>
                        <span  className="sr-only">link to host's linkedIn profile</span>
                    </a> : null
            }
        </div>
    );
}

const renderHostAvatar = (avatar) => {
    if (!avatar) return null;

    return (
        <div className="hostImageContainer">
            <img className="hostImage" src={Utils.appendSizeToImageUrl(avatar, 200)} alt='The host of the event' />
        </div>
    );
}

export default Hosts;